import axios from 'axios';

// Base URL for API
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://cafe9phuochai.com/api';

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 10000 // 10 seconds timeout
});

// Image Upload API (Tải ảnh lên 2 thư mục riêng biệt: 'menu' hoặc 'gallery')
export const apiUploadImage = async (file, type = 'menu') => {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('type', type);

    const res = await axios.post(`${API_BASE_URL}/upload/upload.php`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        timeout: 20000
    });
    return res.data;
};

// Menu Items API
export const apiGetMenu = async () => {
    const res = await apiClient.get('/menu/get.php');
    return res.data;
};

export const apiCreateMenuItem = async (menuData) => {
    const res = await apiClient.post('/menu/create.php', menuData);
    return res.data;
};

export const apiUpdateMenuItem = async (menuData) => {
    const res = await apiClient.post('/menu/update.php', menuData);
    return res.data;
};

export const apiDeleteMenuItem = async (id) => {
    const res = await apiClient.post('/menu/delete.php', { id });
    return res.data;
};

// Gallery Items API
export const apiGetGallery = async () => {
    const res = await apiClient.get('/gallery/get.php');
    return res.data;
};

export const apiCreateGalleryItem = async (galleryData) => {
    const res = await apiClient.post('/gallery/create.php', galleryData);
    return res.data;
};

export const apiUpdateGalleryItem = async (galleryData) => {
    const res = await apiClient.post('/gallery/update.php', galleryData);
    return res.data;
};

export const apiDeleteGalleryItem = async (id) => {
    const res = await apiClient.post('/gallery/delete.php', { id });
    return res.data;
};

// Reviews API
export const apiGetReviews = async () => {
    const res = await apiClient.get('/reviews/get.php');
    return res.data;
};

export const apiCreateReview = async (reviewData) => {
    const res = await apiClient.post('/reviews/create.php', reviewData);
    return res.data;
};

export const apiDeleteReview = async (id) => {
    const res = await apiClient.post('/reviews/delete.php', { id });
    return res.data;
};

// Announcements API
export const apiGetAnnouncements = async (onlyActive = false) => {
    const url = onlyActive ? '/announcements/get.php?active=1' : '/announcements/get.php';
    const res = await apiClient.get(url);
    return res.data;
};

export const apiCreateAnnouncement = async (annData) => {
    const res = await apiClient.post('/announcements/create.php', annData);
    return res.data;
};

export const apiUpdateAnnouncement = async (annData) => {
    const res = await apiClient.post('/announcements/update.php', annData);
    return res.data;
};

export const apiDeleteAnnouncement = async (id) => {
    const res = await apiClient.post('/announcements/delete.php', { id });
    return res.data;
};

// Admin Auth API
export const apiVerifyAdminPin = async (pin) => {
    const res = await apiClient.post('/admin/verify_pin.php', { pin });
    return res.data;
};

export const apiChangeAdminPin = async (newPin) => {
    const res = await apiClient.post('/admin/change_pin.php', { newPin });
    return res.data;
};

// Contact Form API
export const apiSubmitContact = async (contactData) => {
    const res = await apiClient.post('/contact/create.php', contactData);
    return res.data;
};

// Traffic & Browser Analytics Tracking API
export const apiTrackVisit = async () => {
    try {
        if (typeof window === 'undefined') return;

        // Generate or reuse session id in sessionStorage
        const SESS_KEY = 'cafe9_session_id';
        let sessionId = sessionStorage.getItem(SESS_KEY);
        if (!sessionId) {
            sessionId = 'c9_' + Math.random().toString(36).substring(2, 12) + Date.now().toString(36);
            sessionStorage.setItem(SESS_KEY, sessionId);
        }

        const payload = {
            page_url: window.location.pathname + window.location.hash,
            referrer: document.referrer || '',
            screen_resolution: `${window.screen.width}x${window.screen.height}`,
            session_id: sessionId
        };

        // Try sendBeacon first if available (non-blocking)
        const url = `${API_BASE_URL}/analytics/track.php`;
        if (navigator.sendBeacon) {
            const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
            navigator.sendBeacon(url, blob);
        } else {
            await apiClient.post('/analytics/track.php', payload);
        }
    } catch (err) {
        // Silently catch tracking errors so customer experience is completely unaffected
        console.debug("Analytics track error:", err.message);
    }
};

export default apiClient;

